export default __webpack_public_path__ + "static/media/footBall_ground.604468fd.png";